import { render } from "./DailyOverview.vue?vue&type=template&id=6273a7a2"
import script from "./DailyOverview.vue?vue&type=script&lang=js"
export * from "./DailyOverview.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__